export function groupAssignmentsByEngineer(assignments) {
    if (!Array.isArray(assignments)) return [];
    const map = new Map();
    for (const a of assignments) {
        if (!a || a.status === 'Cancelled') continue;
        const id = a.engineer_id;
        if (!id) continue;
        if (!map.has(id)) {
            map.set(id, {
                engineer_id: id,
                name: a.engineer
                    ? `${a.engineer.first_name || ''} ${a.engineer.last_name || ''}`.trim() || id
                    : id,
                days: [],
            });
        }
        map.get(id).days.push({
            assignment_id: a.assignment_id,
            scheduled_date: a.scheduled_date,
            start_time: a.start_time || null,
            end_time: a.end_time || null,
            status: a.status || 'Assigned',
        });
    }
    for (const eng of map.values()) {
        eng.days.sort((x, y) => (x.scheduled_date || 0) - (y.scheduled_date || 0));
    }
    return Array.from(map.values());
}
